import * as React from "react";
import { PureComponent } from "react";
import "./style.scss";
import AppContext from "../../context/AppContext";
import Glyphicon from "../Glyphicon";
import Wyjazd from "../Wyjazd";
import { getButtonClassName } from "./functions";

class Wyjazdy extends PureComponent {
  static contextType = AppContext;

  showAll = () => {
    const { showAllTrips } = this.context;
    showAllTrips();
  };

  hideAll = () => {
    const { hideAllTrips } = this.context;
    hideAllTrips();
  };

  render() {
    const { trips } = this.context;
    return (
      <div className="Wyjazdy">
        <div className="Wyjazdy_wrapper">
          <div className="Wyjazdy_header">
            Lista wyjazdów
            <button
              className={getButtonClassName("show", trips)}
              onClick={this.showAll}
              title="Pokaż wszystkie wyjazdy"
            >
              <Glyphicon icon="visibility" className="Wyjazdy_icon" />
            </button>
            <button
              className={getButtonClassName("hide", trips)}
              onClick={this.hideAll}
              title="Ukryj wszystkie wyjazdy"
            >
              <Glyphicon icon="visibility_off" className="Wyjazdy_icon" />
            </button>
          </div>
          <div className="Wyjazdy_body">
            {trips
              .filter(
                (trip: any) =>
                  trip.hidden !== true && trip.isFiltered && !trip.isFutureTrip
              )
              .map((trip: any) => (
                <Wyjazd key={trip.id} trip={trip} />
              ))}
          </div>
        </div>
      </div>
    );
  }
}

export default Wyjazdy;
